// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3q0i-","errorLogs":"styles_errorLogs__1Wul-"};